import { formatNumberBasedOnValue } from "@/lib/globalFormatterHelper";
import tradeBlockDataStore, {
  IBlockAssigned,
} from "@/store/tradeBlockDataStore";
import { sendCouponValuesToDatabase } from "@/services/ActionSummaryTableSERVICES";
import { useAuth0 } from "@auth0/auth0-react";
import { useTheme } from "next-themes";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { toast } from "react-toastify";

const CouponSwapCellEditor = forwardRef((params: any, ref) => {
  const { getAccessTokenSilently } = useAuth0();
  const { theme } = useTheme();
  const fullTradeData = params.colDef.cellRendererParams.fullTradeData;

  const notationToShow = params.data.notation || "";

  const decimalAmount = formatNumberBasedOnValue(notationToShow);

  const initialValueStr = (() => {
    const initialValue = params.value ?? "";
    const fixed = Number(initialValue).toFixed(decimalAmount);
    return parseFloat(fixed).toString();
  })();
  const [value, setValue] = useState(initialValueStr);
  const valueRef = useRef(initialValueStr);

  const inputRef = useRef<HTMLInputElement>(null);

  const validateAndSave = () => {
    const floatValue = parseFloat(valueRef.current);
    if (isNaN(floatValue)) return null;
    const newValue = parseFloat(floatValue.toFixed(12));

    sendCouponValuesToDatabase(
      { oldValue: params.value, newValue, data: params.data },
      fullTradeData.esid,
      getAccessTokenSilently,
    );

    return newValue;
  };

  useImperativeHandle(ref, () => ({
    getValue: () => validateAndSave(),
    isCancelAfterEnd: () => false,
  }));

  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 0);
  }, []);

  const currentTradeBlockData = tradeBlockDataStore(
    (state) => state.tradeBlockData,
  );
  const theseBlocks = currentTradeBlockData.find(
    (blocks) =>
      blocks.esid == params.colDef.cellRendererParams.fullTradeData.esid,
  );
  const thisBlock = theseBlocks?.blocks?.find(
    (block) => block.id == params.data.id,
  );

  const fieldToCheck = params.colDef.field as keyof IBlockAssigned;

  if (!thisBlock) {
    return;
  }

  if (thisBlock[fieldToCheck] == null || thisBlock[fieldToCheck] == undefined) {
    return;
  }

  // Helper: limit decimal places
  // const limitDecimalPlaces = (input: string, limit: number) => {
  //   const [intPart, decimalPart] = input.split(".");
  //   if (!decimalPart) return input;
  //   return `${intPart}.${decimalPart.substring(0, limit)}`;
  // };

  const handleChange = (e: any) => {
    let input = e.target.value;

    // Allow negative sign, digits, and decimal point
    if (!/^-?\d*\.?\d*$/.test(input)) return;

    // Limit decimal places
    // input = limitDecimalPlaces(input, decimalAmount);

    // Optionally clamp between -100 and 100
    const num = parseFloat(input);
    if (!isNaN(num)) {
      const notaiton = thisBlock.notation;
      if (notaiton == "%") {
        if (num < -100) {
          input = value;
          toast.error("Exceeded maximum range for % coupon value.");
        } else if (num > 100) {
          input = value;
          toast.error("Exceeded maximum range for % coupon value.");
        }
      } else if (notaiton == "bps") {
        if (num < -10000) {
          input = value;
          toast.error("Exceeded maximum range for bps coupon value.");
        } else if (num > 10000) {
          input = value;
          toast.error("Exceeded maximum range for bps coupon value.");
        }
      }
    }
    valueRef.current = input;
    setValue(input);
  };
  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      params.stopEditing();
    } else if (e.key === "Escape") {
      params.cancelEditing();
    }
    // Let Tab propagate to move to next cell
  };

  // function getStepForValue(val: string, maxDecimals: number): string {
  //   if (!val || isNaN(Number(val))) {
  //     // Default to max precision (e.g. 6 decimals)
  //     return (1 / Math.pow(10, maxDecimals)).toString();
  //   }

  //   const match = val.match(/\.(\d+)/);
  //   const decimalCount = match ? match[1].length : 0;

  //   const limitedDecimals = Math.min(decimalCount, maxDecimals);
  //   return (1 / Math.pow(10, limitedDecimals)).toString(); // e.g. "0.001"
  // }

  // Removed code for step changes - no other quote cells are using this. Will need to either include it everywhere or not have it.

  // const inputStep = getStepForValue(value, decimalAmount);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <input
        ref={inputRef}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        className={`${
          theme == "light"
            ? "inputCellOtherLight inputCellLight"
            : " inputCellDark"
        } ag-input ag-roundedInputStyle justify-center !border-none text-center`}
        style={{ width: "100%" }}
        type="number"
        min="-10000"
        max="10000"
        // step={inputStep} // e.g., 0.000001
      />
      {/* {error && (
        <span style={{ color: "red", fontSize: "0.75rem" }}>{error}</span>
      )} */}
    </div>
  );
});

export default CouponSwapCellEditor;
